// https://www.thebalance.com/loan-payment-calculations-315564
export const calculatePayment = (balance, rate, months) => {
  if (rate === 0) {
    return balance / months
  } else {
    const monthlyRate = rate / 12
    return balance / [(Math.pow(1 + monthlyRate, months) - 1) / (monthlyRate * Math.pow(1 + monthlyRate, months))]
  }
}

export const calculateLoanAmount = (payment, rate, months) => {
  const monthlyRate = rate / 12
  return payment * [(Math.pow(1 + monthlyRate, months) - 1) / (monthlyRate * Math.pow(1 + monthlyRate, months))]
}

export const getMonthsToPayoff = (data) => data.findIndex((month) => month[2] === 0)

export const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

// the below calculates the month and year together, which feels more robust
// export const getPayoffDateObject = (monthsToPayoff) => {
//   const d = new Date();
//   d.setMonth(d.getMonth() + monthsToPayoff)
//   return {
//     month: monthNames[d.getMonth()],
//     year: d.getFullYear()
//   }
// }
// switch to this^^ instead of the below, at some point.

export const getPayoffDate = (months) => {
  const date = new Date()
  const yearsInFuture = months / 12
  const monthsFromNow = (months % 12) + date.getMonth()
  const yearsToAdd = monthsFromNow > 12 ? Math.ceil(yearsInFuture) : Math.floor(yearsInFuture)
  const payoffMonth = monthsFromNow % 12
  const payoffYear = date.getFullYear() + yearsToAdd
  return {month: payoffMonth, year: payoffYear}
}

export const getReadableDate = (date) => (date ? `${monthNames[date.month]} ${date.year}` : null)

export const minusPayment = (balance, payment) => Math.max(balance - payment, 0)
export const getPrincipalPayment = (balance, payment, rate) => payment - balance * (rate / 12)

export const getYears = (data) =>
  data.reduce((memo, item, idx) => {
    if (idx % 12 === 0) {
      memo.push([idx / 12, item[1], item[2]])
    }
    return memo
  }, [])
